// Module
var code = "<label>Stripe Service Agreement</label><div class=\"scroll-view\">I authorise {{gymName}} to send instructions to the financial institution that issued my card to take payments from my card account in accordance with the terms of my agreement with you.</div>\n";
// Exports
module.exports = code;